import { useSelector } from 'react-redux';
import { useOnboardingCompletion } from '@/features/client-onboarding/hooks/use-onboarding-completion';

import { selectClient } from '@/model';
import { navigateToPrintReport } from '@client/util/printUtils';

export function useDownloadReportSlide(clientId: string) {
  const client = useSelector(selectClient)!;

  useOnboardingCompletion(clientId);

  const handleDownloadPDF = () => {
    navigateToPrintReport(clientId);
  };

  return {
    client,
    handleDownloadPDF,
  };
}
